









import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import AnalyticAccountTable from '@accounting/components/tables/analytic-account-table/analytic-account-table.vue';

@Component({
  name: 'bpc-analytic-accounts',
  components: {
    'bpc-analytic-account-table': AnalyticAccountTable,
  },
})
export default class AnalyticAccounts extends Vue {}
